<template>
  <button
    class="image-download-button"
    :disabled="downloading"
    @click="$emit('click')">
    <i v-if="downloading" class="el-icon-loading" />
    <i v-else class="mdi mdi-download" />
    <span>
      <slot />
    </span>
  </button>
</template>

<script>
export default {
  props: {
    downloading: {
      type: Boolean,
      default: false
    }
  }

};
</script>

<style lang="scss">
.image-download-button {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: $tooGold;
  cursor: pointer;
  background: none;
  border: none;
  outline: none;

  i {
    padding-right: 5px;
    font-size: 30px;
  }
}
</style>
